import {
  type HostedFolderSelection,
  hostedFolderNameFromFiles,
} from "@/services/hosted-folder-picker"
import { createHostedProject, uploadHostedProject } from "@/services/hosted-projects"

type HostedProjectFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>

export type HostedCustomProjectResult = {
  directory: string
  name: string
  uploadedFiles: number
}

export function hostedCustomProjectName(selection: HostedFolderSelection) {
  return selection.name.trim() || hostedFolderNameFromFiles(selection.files).trim() || "OpenAnalyst Project"
}

export async function createHostedCustomProject(input: {
  serverUrl: string
  selection: HostedFolderSelection
  fetch?: HostedProjectFetch
  validateRuntimeContract?: boolean
}): Promise<HostedCustomProjectResult> {
  const name = hostedCustomProjectName(input.selection)
  if (input.selection.files.length === 0) {
    return {
      ...(await createHostedProject({
        serverUrl: input.serverUrl,
        name,
        fetch: input.fetch,
        validateRuntimeContract: input.validateRuntimeContract,
      })),
      name,
      uploadedFiles: 0,
    }
  }
  return {
    ...(await uploadHostedProject({
      serverUrl: input.serverUrl,
      name,
      files: input.selection.files,
      fetch: input.fetch,
      validateRuntimeContract: input.validateRuntimeContract,
    })),
    name,
  }
}
